import { faCheck } from '@fortawesome/free-solid-svg-icons'

import Icon from './common-parts/Icon'

export default function CheckIcon(props) {
  return (
      <Icon
        size="lg"
        {...props}
        icon={faCheck}
      />
  );
}
